import { NotationBadgeContainer } from 'global/Notation/styled';
import Image from 'global/Image';
import Notation from 'global/Notation';
import { BadgeContainer, SuspendedBadge, UmaBadge } from './styled';
import { SPECIAL_SUBSECTOR_ALIAS } from './constants';

interface IBadge {
  notationList: any[];
  subsectorAlias?: string;
  symbol: string;
  name: string;
}

const Badge = ({ notationList, subsectorAlias, symbol, name }: IBadge) => {
  const showExpandedNotsusBadge =
    subsectorAlias &&
    subsectorAlias.toUpperCase() === SPECIAL_SUBSECTOR_ALIAS.FCA &&
    notationList.length > 0;

  const showMinimizedNotsusBadge =
    subsectorAlias &&
    subsectorAlias.toUpperCase() === SPECIAL_SUBSECTOR_ALIAS.FCA_OUT &&
    notationList.length > 0;

  const showUma = subsectorAlias?.toUpperCase() === SPECIAL_SUBSECTOR_ALIAS.UMA;

  const showSuspend =
    subsectorAlias?.toUpperCase() === SPECIAL_SUBSECTOR_ALIAS.SUSPENDED;

  return (
    <BadgeContainer>
      {showExpandedNotsusBadge && (
        <NotationBadgeContainer>
          {notationList.map((notation, index) => (
            <>
              {notation.notation_code}
              {index < notationList.length - 1 && (
                <Image src="/icon/notsus-badge-dot.svg" alt="" />
              )}
            </>
          ))}
        </NotationBadgeContainer>
      )}
      {showMinimizedNotsusBadge && (
        <Notation
          symbol={symbol}
          notation={notationList}
          uma={false}
          isModal={false}
          name={name}
          isPopover
          isNotationBadges
        />
      )}
      {showUma && (
        <UmaBadge>
          <Image alt="indikator notasi khusus" src="/icon/ic_uma.svg" />
        </UmaBadge>
      )}
      {showSuspend && <SuspendedBadge>Suspended</SuspendedBadge>}
    </BadgeContainer>
  );
};

export default Badge;
